import { Icon } from "@vds/icons";
import { Body } from "@vds/typography";
import { Spin } from "antd";
import { useEffect } from "react";
import styled from "styled-components";
import "../../../styles/cameraSnapshot.css";

const LightText = styled.div`
  color: #6f7171;
  font-feature-settings: "clig" off, "liga" off;
  /* [VDS] DeskTab/🖥 Body LG */
  font-family: "Verizon-NHG-eDS";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.5px;
`;

export const BasicSnapshot = ({
  loading,
  snapshotImage,
  height,
  width,
  style,
  refetchImage,
  refreshImage,
  title,
  setRefreshButtonClicked,
  belowImageSlot,
  onRefetchReady
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (typeof onRefetchReady === "function") {
      onRefetchReady(refetchImage);
    }
  }, []); // intentionally mount-only — refetchImage is stable from HOC closure

  return (
    <>
      {" "}
      {loading ? (
        <div className="camera-snapshot-loading">
          <Spin />
        </div>
      ) : (
        <>
          <div>
            <div style={{ display: "flex" }}>
              {" "}
              {snapshotImage ? (
                <img
                  src={snapshotImage}
                  alt="Stream Snapshot"
                  className="camera-snapshot"
                  style={style}
                />
              ) : (
                <div className="camera-snapshot-error">
                  <div className="camera-snapshot-error-content">
                    <Icon name="error" size="small" color="#6f7171" />
                    <LightText>Snapshot failed to load</LightText>
                  </div>
                </div>
              )}
            </div>
          </div>
          {belowImageSlot}
        </>
      )}
      {refreshImage && (
        <div
          style={{ display: "flex" }}
          data-testid="devices_cameraRefreshSnapshot"
          onClick={() => {
            setRefreshButtonClicked(true);
            refetchImage();
          }}
        >
          <div style={{ margin: "10px 0 20px 0" }}>
            <Body size="large" bold>
              {title}
            </Body>
          </div>

          <div style={{ margin: "10px 10px 0 0", cursor: "pointer" }}>
            <Icon name="sync" size="small" color="#000000" />
          </div>
        </div>
      )}
    </>
  );
};
